// 자동 생성 — /root/i18n/build_regions.py
// 시/도 · 구/군 드롭다운 표시용 다국어 라벨.
// value 는 한국어 원문 그대로 쓰고, 화면에 보이는 라벨만 여기서 바꾼다.

export type RegionLabel = { en: string; zh: string; mn: string };

export const sidoI18n: Record<string, RegionLabel> = {
  '서울': { en: 'Seoul', zh: '首尔', mn: 'Сөүл' },
  '부산': { en: 'Busan', zh: '釜山', mn: 'Пусан' },
  '대구': { en: 'Daegu', zh: '大邱', mn: 'Тэгу' },
  '인천': { en: 'Incheon', zh: '仁川', mn: 'Инчон' },
  '광주': { en: 'Gwangju', zh: '光州', mn: 'Гванжу' },
  '대전': { en: 'Daejeon', zh: '大田', mn: 'Тэжон' },
  '울산': { en: 'Ulsan', zh: '蔚山', mn: 'Улсан' },
  '세종': { en: 'Sejong', zh: '世宗', mn: 'Сежон' },
  '경기': { en: 'Gyeonggi', zh: '京畿', mn: 'Гёнги' },
  '강원': { en: 'Gangwon', zh: '江原', mn: 'Гангвон' },
  '충북': { en: 'Chungbuk', zh: '忠北', mn: 'Чунбук' },
  '충남': { en: 'Chungnam', zh: '忠南', mn: 'Чуннам' },
  '전북': { en: 'Jeonbuk', zh: '全北', mn: 'Жонбук' },
  '전남': { en: 'Jeonnam', zh: '全南', mn: 'Жоннам' },
  '경북': { en: 'Gyeongbuk', zh: '庆北', mn: 'Гёнбук' },
  '경남': { en: 'Gyeongnam', zh: '庆南', mn: 'Гённам' },
  '제주': { en: 'Jeju', zh: '济州', mn: 'Жежу' },
};

export const gugunI18n: Record<string, RegionLabel> = {
  '가평군': { en: 'Gapyeong-gun', zh: '加平郡', mn: 'Гапён-гун' },
  '강남구': { en: 'Gangnam-gu', zh: '江南区', mn: 'Ганнам-гу' },
  '강동구': { en: 'Gangdong-gu', zh: '江东区', mn: 'Гандон-гу' },
  '강릉시': { en: 'Gangneung-si', zh: '江陵市', mn: 'Ганнын-си' },
  '강북구': { en: 'Gangbuk-gu', zh: '江北区', mn: 'Ганбуг-гу' },
  '강서구': { en: 'Gangseo-gu', zh: '江西区', mn: 'Гансо-гу' },
  '강진군': { en: 'Gangjin-gun', zh: '康津郡', mn: 'Ганжин-гун' },
  '강화군': { en: 'Ganghwa-gun', zh: '江华郡', mn: 'Ганхва-гун' },
  '거제시': { en: 'Geoje-si', zh: '巨济市', mn: 'Гожэ-си' },
  '거창군': { en: 'Geochang-gun', zh: '居昌郡', mn: 'Гочан-гун' },
  '경산시': { en: 'Gyeongsan-si', zh: '庆山市', mn: 'Гёнсан-си' },
  '경주시': { en: 'Gyeongju-si', zh: '庆州市', mn: 'Гёнжу-си' },
  '계룡시': { en: 'Gyeryong-si', zh: '鸡龙市', mn: 'Герён-си' },
  '계양구': { en: 'Gyeyang-gu', zh: '桂阳区', mn: 'Геян-гу' },
  '고령군': { en: 'Goryeong-gun', zh: '高灵郡', mn: 'Горён-гун' },
  '고성군': { en: 'Goseong-gun', zh: '固城郡', mn: 'Госон-гун' },
  '고양시 덕양구': { en: 'Goyang-si Deogyang-gu', zh: '高阳市 德阳区', mn: 'Гоян-си Догян-гу' },
  '고양시 일산동구': { en: 'Goyang-si Ilsandong-gu', zh: '高阳市 一山东区', mn: 'Гоян-си Илсандон-гу' },
  '고양시 일산서구': { en: 'Goyang-si Ilsanseo-gu', zh: '高阳市 一山西区', mn: 'Гоян-си Илсансо-гу' },
  '고창군': { en: 'Gochang-gun', zh: '高敞郡', mn: 'Гочан-гун' },
  '고흥군': { en: 'Goheung-gun', zh: '高兴郡', mn: 'Гохын-гун' },
  '곡성군': { en: 'Gokseong-gun', zh: '谷城郡', mn: 'Гогсон-гун' },
  '공주시': { en: 'Gongju-si', zh: '公州市', mn: 'Гонжу-си' },
  '과천시': { en: 'Gwacheon-si', zh: '果川市', mn: 'Гвачон-си' },
  '관악구': { en: 'Gwanak-gu', zh: '冠岳区', mn: 'Гванаг-гу' },
  '광명시': { en: 'Gwangmyeong-si', zh: '光明市', mn: 'Гванмён-си' },
  '광산구': { en: 'Gwangsan-gu', zh: '光山区', mn: 'Гвансан-гу' },
  '광양시': { en: 'Gwangyang-si', zh: '光阳市', mn: 'Гванян-си' },
  '광주시': { en: 'Gwangju-si', zh: '广州市', mn: 'Гванжу-си' },
  '광진구': { en: 'Gwangjin-gu', zh: '广津区', mn: 'Гванжин-гу' },
  '괴산군': { en: 'Goesan-gun', zh: '槐山郡', mn: 'Гвесан-гун' },
  '구례군': { en: 'Gurye-gun', zh: '求礼郡', mn: 'Гуре-гун' },
  '구로구': { en: 'Guro-gu', zh: '九老区', mn: 'Гуро-гу' },
  '구리시': { en: 'Guri-si', zh: '九里市', mn: 'Гури-си' },
  '구미시': { en: 'Gumi-si', zh: '龟尾市', mn: 'Гуми-си' },
  '군산시': { en: 'Gunsan-si', zh: '群山市', mn: 'Гунсан-си' },
  '군위군': { en: 'Gunwi-gun', zh: '军威郡', mn: 'Гунви-гун' },
  '군포시': { en: 'Gunpo-si', zh: '军浦市', mn: 'Гунпо-си' },
  '금산군': { en: 'Geumsan-gun', zh: '锦山郡', mn: 'Гымсан-гун' },
  '금정구': { en: 'Geumjeong-gu', zh: '金井区', mn: 'Гымжон-гу' },
  '금천구': { en: 'Geumcheon-gu', zh: '衿川区', mn: 'Гымчон-гу' },
  '기장군': { en: 'Gijang-gun', zh: '机张郡', mn: 'Гижан-гун' },
  '김제시': { en: 'Gimje-si', zh: '金堤市', mn: 'Гимжэ-си' },
  '김천시': { en: 'Gimcheon-si', zh: '金泉市', mn: 'Гимчон-си' },
  '김포시': { en: 'Gimpo-si', zh: '金浦市', mn: 'Гимпо-си' },
  '김해시': { en: 'Gimhae-si', zh: '金海市', mn: 'Гимхэ-си' },
  '나주시': { en: 'Naju-si', zh: '罗州市', mn: 'Нажу-си' },
  '남구': { en: 'Nam-gu', zh: '南区', mn: 'Нам-гу' },
  '남동구': { en: 'Namdong-gu', zh: '南洞区', mn: 'Намдон-гу' },
  '남양주시': { en: 'Namyangju-si', zh: '南杨州市', mn: 'Намянжу-си' },
  '남원시': { en: 'Namwon-si', zh: '南原市', mn: 'Намвон-си' },
  '남해군': { en: 'Namhae-gun', zh: '南海郡', mn: 'Намхэ-гун' },
  '노원구': { en: 'Nowon-gu', zh: '芦原区', mn: 'Новон-гу' },
  '논산시': { en: 'Nonsan-si', zh: '论山市', mn: 'Нонсан-си' },
  '단양군': { en: 'Danyang-gun', zh: '丹阳郡', mn: 'Данян-гун' },
  '달서구': { en: 'Dalseo-gu', zh: '达西区', mn: 'Далсо-гу' },
  '달성군': { en: 'Dalseong-gun', zh: '达城郡', mn: 'Далсон-гун' },
  '담양군': { en: 'Damyang-gun', zh: '潭阳郡', mn: 'Дамян-гун' },
  '당진시': { en: 'Dangjin-si', zh: '唐津市', mn: 'Данжин-си' },
  '대덕구': { en: 'Daedeok-gu', zh: '大德区', mn: 'Дэдог-гу' },
  '도봉구': { en: 'Dobong-gu', zh: '道峰区', mn: 'Добон-гу' },
  '동구': { en: 'Dong-gu', zh: '东区', mn: 'Дон-гу' },
  '동대문구': { en: 'Dongdaemun-gu', zh: '东大门区', mn: 'Дондэмун-гу' },
  '동두천시': { en: 'Dongducheon-si', zh: '东豆川市', mn: 'Дондучон-си' },
  '동래구': { en: 'Dongnae-gu', zh: '东莱区', mn: 'Доннэ-гу' },
  '동작구': { en: 'Dongjak-gu', zh: '铜雀区', mn: 'Донжаг-гу' },
  '동해시': { en: 'Donghae-si', zh: '东海市', mn: 'Донхэ-си' },
  '마포구': { en: 'Mapo-gu', zh: '麻浦区', mn: 'Мапо-гу' },
  '목포시': { en: 'Mokpo-si', zh: '木浦市', mn: 'Могпо-си' },
  '무안군': { en: 'Muan-gun', zh: '务安郡', mn: 'Муан-гун' },
  '무주군': { en: 'Muju-gun', zh: '茂朱郡', mn: 'Мужу-гун' },
  '문경시': { en: 'Mungyeong-si', zh: '闻庆市', mn: 'Мунгён-си' },
  '밀양시': { en: 'Miryang-si', zh: '密阳市', mn: 'Милян-си' },
  '보령시': { en: 'Boryeong-si', zh: '保宁市', mn: 'Борён-си' },
  '보성군': { en: 'Boseong-gun', zh: '宝城郡', mn: 'Босон-гун' },
  '보은군': { en: 'Boeun-gun', zh: '报恩郡', mn: 'Боын-гун' },
  '봉화군': { en: 'Bonghwa-gun', zh: '奉化郡', mn: 'Бонхва-гун' },
  '부산진구': { en: 'Busanjin-gu', zh: '釜山镇区', mn: 'Пусанжин-гу' },
  '부안군': { en: 'Buan-gun', zh: '扶安郡', mn: 'Буан-гун' },
  '부여군': { en: 'Buyeo-gun', zh: '扶余郡', mn: 'Буё-гун' },
  '부천시': { en: 'Bucheon-si', zh: '富川市', mn: 'Бучон-си' },
  '부평구': { en: 'Bupyeong-gu', zh: '富平区', mn: 'Бупён-гу' },
  '북구': { en: 'Buk-gu', zh: '北区', mn: 'Буг-гу' },
  '사상구': { en: 'Sasang-gu', zh: '沙上区', mn: 'Сасан-гу' },
  '사천시': { en: 'Sacheon-si', zh: '泗川市', mn: 'Сачон-си' },
  '사하구': { en: 'Saha-gu', zh: '沙下区', mn: 'Саха-гу' },
  '산청군': { en: 'Sancheong-gun', zh: '山清郡', mn: 'Санчон-гун' },
  '삼척시': { en: 'Samcheok-si', zh: '三陟市', mn: 'Самчог-си' },
  '상주시': { en: 'Sangju-si', zh: '尚州市', mn: 'Санжу-си' },
  '서구': { en: 'Seo-gu', zh: '西区', mn: 'Со-гу' },
  '서귀포시': { en: 'Seogwipo-si', zh: '西归浦市', mn: 'Согвипо-си' },
  '서대문구': { en: 'Seodaemun-gu', zh: '西大门区', mn: 'Содэмун-гу' },
  '서산시': { en: 'Seosan-si', zh: '瑞山市', mn: 'Сосан-си' },
  '서천군': { en: 'Seocheon-gun', zh: '舒川郡', mn: 'Сочон-гун' },
  '서초구': { en: 'Seocho-gu', zh: '瑞草区', mn: 'Сочо-гу' },
  '성남시 분당구': { en: 'Seongnam-si Bundang-gu', zh: '城南市 盆唐区', mn: 'Соннам-си Бундан-гу' },
  '성남시 수정구': { en: 'Seongnam-si Sujeong-gu', zh: '城南市 寿井区', mn: 'Соннам-си Сужон-гу' },
  '성남시 중원구': { en: 'Seongnam-si Jungwon-gu', zh: '城南市 中院区', mn: 'Соннам-си Жунвон-гу' },
  '성동구': { en: 'Seongdong-gu', zh: '城东区', mn: 'Сондон-гу' },
  '성북구': { en: 'Seongbuk-gu', zh: '城北区', mn: 'Сонбуг-гу' },
  '성주군': { en: 'Seongju-gun', zh: '星州郡', mn: 'Сонжу-гун' },
  '세종특별자치시': { en: 'Sejong-si', zh: '世宗市', mn: 'Сежон-си' },
  '속초시': { en: 'Sokcho-si', zh: '束草市', mn: 'Согчо-си' },
  '송파구': { en: 'Songpa-gu', zh: '松坡区', mn: 'Сонпа-гу' },
  '수성구': { en: 'Suseong-gu', zh: '寿城区', mn: 'Сусон-гу' },
  '수영구': { en: 'Suyeong-gu', zh: '水营区', mn: 'Суён-гу' },
  '수원시 권선구': { en: 'Suwon-si Gwonseon-gu', zh: '水原市 劝善区', mn: 'Сувон-си Гвонсон-гу' },
  '수원시 영통구': { en: 'Suwon-si Yeongtong-gu', zh: '水原市 灵通区', mn: 'Сувон-си Ёнтон-гу' },
  '수원시 장안구': { en: 'Suwon-si Jangan-gu', zh: '水原市 长安区', mn: 'Сувон-си Жанан-гу' },
  '수원시 팔달구': { en: 'Suwon-si Paldal-gu', zh: '水原市 八达区', mn: 'Сувон-си Палдал-гу' },
  '순창군': { en: 'Sunchang-gun', zh: '淳昌郡', mn: 'Сунчан-гун' },
  '순천시': { en: 'Suncheon-si', zh: '顺天市', mn: 'Сунчон-си' },
  '시흥시': { en: 'Siheung-si', zh: '始兴市', mn: 'Сихын-си' },
  '신안군': { en: 'Sinan-gun', zh: '新安郡', mn: 'Синан-гун' },
  '아산시': { en: 'Asan-si', zh: '牙山市', mn: 'Асан-си' },
  '안동시': { en: 'Andong-si', zh: '安东市', mn: 'Андон-си' },
  '안산시 단원구': { en: 'Ansan-si Danwon-gu', zh: '安山市 檀园区', mn: 'Ансан-си Данвон-гу' },
  '안산시 상록구': { en: 'Ansan-si Sangnok-gu', zh: '安山市 常绿区', mn: 'Ансан-си Санног-гу' },
  '안양시 동안구': { en: 'Anyang-si Dongan-gu', zh: '安养市 东安区', mn: 'Анян-си Донан-гу' },
  '안양시 만안구': { en: 'Anyang-si Manan-gu', zh: '安养市 万安区', mn: 'Анян-си Манан-гу' },
  '양구군': { en: 'Yanggu-gun', zh: '杨口郡', mn: 'Янгу-гун' },
  '양산시': { en: 'Yangsan-si', zh: '梁山市', mn: 'Янсан-си' },
  '양양군': { en: 'Yangyang-gun', zh: '襄阳郡', mn: 'Янян-гун' },
  '양주시': { en: 'Yangju-si', zh: '杨州市', mn: 'Янжу-си' },
  '양천구': { en: 'Yangcheon-gu', zh: '阳川区', mn: 'Янчон-гу' },
  '양평군': { en: 'Yangpyeong-gun', zh: '杨平郡', mn: 'Янпён-гун' },
  '여수시': { en: 'Yeosu-si', zh: '丽水市', mn: 'Ёсу-си' },
  '여주시': { en: 'Yeoju-si', zh: '骊州市', mn: 'Ёжу-си' },
  '연수구': { en: 'Yeonsu-gu', zh: '延寿区', mn: 'Ёнсу-гу' },
  '연제구': { en: 'Yeonje-gu', zh: '莲堤区', mn: 'Ёнжэ-гу' },
  '연천군': { en: 'Yeoncheon-gun', zh: '涟川郡', mn: 'Ёнчон-гун' },
  '영광군': { en: 'Yeonggwang-gun', zh: '灵光郡', mn: 'Ёнгван-гун' },
  '영덕군': { en: 'Yeongdeok-gun', zh: '盈德郡', mn: 'Ёндог-гун' },
  '영도구': { en: 'Yeongdo-gu', zh: '影岛区', mn: 'Ёндо-гу' },
  '영동군': { en: 'Yeongdong-gun', zh: '永同郡', mn: 'Ёндон-гун' },
  '영등포구': { en: 'Yeongdeungpo-gu', zh: '永登浦区', mn: 'Ёндынпо-гу' },
  '영암군': { en: 'Yeongam-gun', zh: '灵岩郡', mn: 'Ёнам-гун' },
  '영양군': { en: 'Yeongyang-gun', zh: '英阳郡', mn: 'Ёнян-гун' },
  '영월군': { en: 'Yeongwol-gun', zh: '宁越郡', mn: 'Ёнвол-гун' },
  '영주시': { en: 'Yeongju-si', zh: '荣州市', mn: 'Ёнжу-си' },
  '영천시': { en: 'Yeongcheon-si', zh: '永川市', mn: 'Ёнчон-си' },
  '예산군': { en: 'Yesan-gun', zh: '礼山郡', mn: 'Есан-гун' },
  '예천군': { en: 'Yecheon-gun', zh: '醴泉郡', mn: 'Ечон-гун' },
  '오산시': { en: 'Osan-si', zh: '乌山市', mn: 'Осан-си' },
  '옥천군': { en: 'Okcheon-gun', zh: '沃川郡', mn: 'Огчон-гун' },
  '옹진군': { en: 'Ongjin-gun', zh: '瓮津郡', mn: 'Онжин-гун' },
  '완도군': { en: 'Wando-gun', zh: '莞岛郡', mn: 'Вандо-гун' },
  '완주군': { en: 'Wanju-gun', zh: '完州郡', mn: 'Ванжу-гун' },
  '용산구': { en: 'Yongsan-gu', zh: '龙山区', mn: 'Ёнсан-гу' },
  '용인시 기흥구': { en: 'Yongin-si Giheung-gu', zh: '龙仁市 器兴区', mn: 'Ёнин-си Гихын-гу' },
  '용인시 수지구': { en: 'Yongin-si Suji-gu', zh: '龙仁市 水枝区', mn: 'Ёнин-си Сужи-гу' },
  '용인시 처인구': { en: 'Yongin-si Cheoin-gu', zh: '龙仁市 处仁区', mn: 'Ёнин-си Чоин-гу' },
  '울릉군': { en: 'Ulleung-gun', zh: '郁陵郡', mn: 'Уллын-гун' },
  '울주군': { en: 'Ulju-gun', zh: '蔚州郡', mn: 'Улжу-гун' },
  '울진군': { en: 'Uljin-gun', zh: '蔚珍郡', mn: 'Улжин-гун' },
  '원주시': { en: 'Wonju-si', zh: '原州市', mn: 'Вонжу-си' },
  '유성구': { en: 'Yuseong-gu', zh: '儒城区', mn: 'Юсон-гу' },
  '은평구': { en: 'Eunpyeong-gu', zh: '恩平区', mn: 'Ынпён-гу' },
  '음성군': { en: 'Eumseong-gun', zh: '阴城郡', mn: 'Ымсон-гун' },
  '의령군': { en: 'Uiryeong-gun', zh: '宜宁郡', mn: 'Ыйрён-гун' },
  '의성군': { en: 'Uiseong-gun', zh: '义城郡', mn: 'Ыйсон-гун' },
  '의왕시': { en: 'Uiwang-si', zh: '义王市', mn: 'Ыйван-си' },
  '의정부시': { en: 'Uijeongbu-si', zh: '议政府市', mn: 'Ыйжонбу-си' },
  '이천시': { en: 'Icheon-si', zh: '利川市', mn: 'Ичон-си' },
  '익산시': { en: 'Iksan-si', zh: '益山市', mn: 'Игсан-си' },
  '인제군': { en: 'Inje-gun', zh: '麟蹄郡', mn: 'Инжэ-гун' },
  '임실군': { en: 'Imsil-gun', zh: '任实郡', mn: 'Имсил-гун' },
  '장성군': { en: 'Jangseong-gun', zh: '长城郡', mn: 'Жансон-гун' },
  '장수군': { en: 'Jangsu-gun', zh: '长水郡', mn: 'Жансу-гун' },
  '장흥군': { en: 'Jangheung-gun', zh: '长兴郡', mn: 'Жанхын-гун' },
  '전주시 덕진구': { en: 'Jeonju-si Deokjin-gu', zh: '全州市 德津区', mn: 'Жонжу-си Догжин-гу' },
  '전주시 완산구': { en: 'Jeonju-si Wansan-gu', zh: '全州市 完山区', mn: 'Жонжу-си Вансан-гу' },
  '정선군': { en: 'Jeongseon-gun', zh: '旌善郡', mn: 'Жонсон-гун' },
  '정읍시': { en: 'Jeongeup-si', zh: '井邑市', mn: 'Жоныб-си' },
  '제주시': { en: 'Jeju-si', zh: '济州市', mn: 'Жежу-си' },
  '제천시': { en: 'Jecheon-si', zh: '堤川市', mn: 'Жэчон-си' },
  '종로구': { en: 'Jongno-gu', zh: '钟路区', mn: 'Жонно-гу' },
  '중구': { en: 'Jung-gu', zh: '中区', mn: 'Жун-гу' },
  '중랑구': { en: 'Jungnang-gu', zh: '中浪区', mn: 'Жуннан-гу' },
  '증평군': { en: 'Jeungpyeong-gun', zh: '曾坪郡', mn: 'Жынпён-гун' },
  '진도군': { en: 'Jindo-gun', zh: '珍岛郡', mn: 'Жиндо-гун' },
  '진안군': { en: 'Jinan-gun', zh: '镇安郡', mn: 'Жинан-гун' },
  '진주시': { en: 'Jinju-si', zh: '晋州市', mn: 'Жинжу-си' },
  '진천군': { en: 'Jincheon-gun', zh: '镇川郡', mn: 'Жинчон-гун' },
  '창녕군': { en: 'Changnyeong-gun', zh: '昌宁郡', mn: 'Чаннён-гун' },
  '창원시 마산합포구': { en: 'Changwon-si Masanhappo-gu', zh: '昌原市 马山合浦区', mn: 'Чанвон-си Масанхабпо-гу' },
  '창원시 마산회원구': { en: 'Changwon-si Masanhoewon-gu', zh: '昌原市 马山会原区', mn: 'Чанвон-си Масанхвевон-гу' },
  '창원시 성산구': { en: 'Changwon-si Seongsan-gu', zh: '昌原市 城山区', mn: 'Чанвон-си Сонсан-гу' },
  '창원시 의창구': { en: 'Changwon-si Uichang-gu', zh: '昌原市 义昌区', mn: 'Чанвон-си Ыйчан-гу' },
  '창원시 진해구': { en: 'Changwon-si Jinhae-gu', zh: '昌原市 镇海区', mn: 'Чанвон-си Жинхэ-гу' },
  '천안시 동남구': { en: 'Cheonan-si Dongnam-gu', zh: '天安市 东南区', mn: 'Чонан-си Доннам-гу' },
  '천안시 서북구': { en: 'Cheonan-si Seobuk-gu', zh: '天安市 西北区', mn: 'Чонан-си Собуг-гу' },
  '철원군': { en: 'Cheorwon-gun', zh: '铁原郡', mn: 'Чолвон-гун' },
  '청도군': { en: 'Cheongdo-gun', zh: '清道郡', mn: 'Чондо-гун' },
  '청송군': { en: 'Cheongsong-gun', zh: '青松郡', mn: 'Чонсон-гун' },
  '청양군': { en: 'Cheongyang-gun', zh: '青阳郡', mn: 'Чонян-гун' },
  '청주시 상당구': { en: 'Cheongju-si Sangdang-gu', zh: '清州市 上党区', mn: 'Чонжу-си Сандан-гу' },
  '청주시 서원구': { en: 'Cheongju-si Seowon-gu', zh: '清州市 西原区', mn: 'Чонжу-си Совон-гу' },
  '청주시 청원구': { en: 'Cheongju-si Cheongwon-gu', zh: '清州市 清原区', mn: 'Чонжу-си Чонвон-гу' },
  '청주시 흥덕구': { en: 'Cheongju-si Heungdeok-gu', zh: '清州市 兴德区', mn: 'Чонжу-си Хындог-гу' },
  '춘천시': { en: 'Chuncheon-si', zh: '春川市', mn: 'Чунчон-си' },
  '충주시': { en: 'Chungju-si', zh: '忠州市', mn: 'Чунжу-си' },
  '칠곡군': { en: 'Chilgok-gun', zh: '漆谷郡', mn: 'Чилгог-гун' },
  '태백시': { en: 'Taebaek-si', zh: '太白市', mn: 'Тэбэг-си' },
  '태안군': { en: 'Taean-gun', zh: '泰安郡', mn: 'Тэан-гун' },
  '통영시': { en: 'Tongyeong-si', zh: '统营市', mn: 'Тонён-си' },
  '파주시': { en: 'Paju-si', zh: '坡州市', mn: 'Пажу-си' },
  '평창군': { en: 'Pyeongchang-gun', zh: '平昌郡', mn: 'Пёнчан-гун' },
  '평택시': { en: 'Pyeongtaek-si', zh: '平泽市', mn: 'Пёнтэг-си' },
  '포천시': { en: 'Pocheon-si', zh: '抱川市', mn: 'Почон-си' },
  '포항시 남구': { en: 'Pohang-si Nam-gu', zh: '浦项市 南区', mn: 'Похан-си Нам-гу' },
  '포항시 북구': { en: 'Pohang-si Buk-gu', zh: '浦项市 北区', mn: 'Похан-си Буг-гу' },
  '하남시': { en: 'Hanam-si', zh: '河南市', mn: 'Ханам-си' },
  '하동군': { en: 'Hadong-gun', zh: '河东郡', mn: 'Хадон-гун' },
  '함안군': { en: 'Haman-gun', zh: '咸安郡', mn: 'Хаман-гун' },
  '함양군': { en: 'Hamyang-gun', zh: '咸阳郡', mn: 'Хамян-гун' },
  '함평군': { en: 'Hampyeong-gun', zh: '咸平郡', mn: 'Хампён-гун' },
  '합천군': { en: 'Hapcheon-gun', zh: '陕川郡', mn: 'Хабчон-гун' },
  '해남군': { en: 'Haenam-gun', zh: '海南郡', mn: 'Хэнам-гун' },
  '해운대구': { en: 'Haeundae-gu', zh: '海云台区', mn: 'Хэундэ-гу' },
  '홍성군': { en: 'Hongseong-gun', zh: '洪城郡', mn: 'Хонсон-гун' },
  '홍천군': { en: 'Hongcheon-gun', zh: '洪川郡', mn: 'Хончон-гун' },
  '화성시': { en: 'Hwaseong-si', zh: '华城市', mn: 'Хвасон-си' },
  '화순군': { en: 'Hwasun-gun', zh: '和顺郡', mn: 'Хвасун-гун' },
  '화천군': { en: 'Hwacheon-gun', zh: '华川郡', mn: 'Хвачон-гун' },
  '횡성군': { en: 'Hoengseong-gun', zh: '横城郡', mn: 'Хвенсон-гун' },
};

